import React from "react";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import GlobalBreadcrumb from "./GlobalBreadcrumb";
import TopNavBar from "./TopNavBar";
import { useAuth } from "../context/AuthContext";

export default function MainLayout({ children, sidebarOpen, toggleSidebar, hideBreadcrumb, title, subtitle, showSearch }) {
  const { user, logout } = useAuth();

  return (
    <div className="page container">
      {sidebarOpen && <div className="overlay" onClick={toggleSidebar}></div>}
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      <main className="main" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', padding: 0, background: '#f8fafc' }}>
        <div className="hamburger" onClick={toggleSidebar}>☰</div>

        <TopNavBar
          user={user}
          notifications={0}
          toggleSidebar={toggleSidebar}
          logout={logout}
          title={title}
          subtitle={subtitle}
          showSearch={showSearch}
          style={{ position: 'sticky', background: '#fff', borderBottom: '1px solid #e2e8f0', zIndex: 1000 }}
        />

        {!hideBreadcrumb && <GlobalBreadcrumb />}
        <div style={{ flex: 1, padding: '0 20px 20px' }}>
          {children}
        </div>
        <Footer />
      </main>
    </div>
  );
}